import { useCallback } from 'react';
import { useAppDispatch } from '@/store/hooks';
import { showSnackbar, hideSnackbar } from '@/store/slices/uiSlice';

export const useSnackbar = () => {
	const dispatch = useAppDispatch();

	const showSuccess = useCallback((message: string) => {
		dispatch(showSnackbar({ message, severity: 'success' }));
	}, [dispatch]);

	const showError = useCallback((message: string) => {
		dispatch(showSnackbar({ message, severity: 'error' }));
	}, [dispatch]);

	const showWarning = useCallback((message: string) => {
		dispatch(showSnackbar({ message, severity: 'warning' }));
	}, [dispatch]);

	const showInfo = useCallback((message: string) => {
		dispatch(showSnackbar({ message, severity: 'info' }));
	}, [dispatch]);

	const hide = useCallback(() => {
		dispatch(hideSnackbar());
	}, [dispatch]);

	return {
		showSuccess,
		showError,
		showWarning,
		showInfo,
		hide
	};
};
